import { render, staticRenderFns } from "./relatorioOperacoes.vue?vue&type=template&id=381f5344"
import script from "./relatorioOperacoes.vue?vue&type=script&lang=js"
export * from "./relatorioOperacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports